export const baseURL = "https://casino.elportalo.com/";
export const adminBaseURL = "https://admin.elportalo.com/";
export const key = "499x!72&vz3d^ermx&4i4*^&9gt_@uzr)&m8jz-&xjq5x%h";